import React, { useEffect, useRef } from 'react';

const SmsEditor = ({
  variables = [],
  value = '',
  onChange = () => {},
  disabled = false,
  placeholder = 'Type your SMS content...',
}) => {
  const editorRef = useRef(null);

  const insertVariable = (varName) => {
    if (disabled) return;

    const span = document.createElement('span');
    span.contentEditable = 'false';
    span.textContent = `{{${varName}}}`;
    span.setAttribute('data-var', varName);
    span.style.backgroundColor = '#e0f2fe';
    span.style.border = '1px solid #60a5fa';
    span.style.padding = '2px 4px';
    span.style.margin = '0 2px';
    span.style.borderRadius = '4px';

    const selection = window.getSelection();

    if (document.activeElement !== editorRef.current) {
      editorRef.current.focus();
      const range = document.createRange();
      range.selectNodeContents(editorRef.current);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      range.deleteContents();
      range.insertNode(span);
      range.setStartAfter(span);
      range.setEndAfter(span);
      selection.removeAllRanges();
      selection.addRange(range);
    }

    triggerChange();
  };

  const triggerChange = () => {
    const children = Array.from(editorRef.current.childNodes);
    const result = children
      .map((node) => {
        if (node.nodeType === 3) return node.textContent;
        if (node.nodeType === 1 && node.dataset.var) return `{{${node.dataset.var}}}`;
        return '';
      })
      .join('');
    onChange(result);
  };

  useEffect(() => {
    if (!editorRef.current) return;
    editorRef.current.innerHTML = '';
    const regex = /{{(.*?)}}/g;
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(value)) !== null) {
      const text = value.substring(lastIndex, match.index);
      if (text) editorRef.current.appendChild(document.createTextNode(text));

      const span = document.createElement('span');
      span.contentEditable = 'false';
      span.textContent = `{{${match[1]}}}`;
      span.setAttribute('data-var', match[1]);
      span.style.backgroundColor = '#e0f2fe';
      span.style.border = '1px solid #60a5fa';
      span.style.padding = '2px 4px';
      span.style.margin = '0 2px';
      span.style.borderRadius = '4px';
      editorRef.current.appendChild(span);

      lastIndex = match.index + match[0].length;
    }

    const remaining = value.slice(lastIndex);
    if (remaining) {
      editorRef.current.appendChild(document.createTextNode(remaining));
    }
  }, [value]);

  return (
    <div style={{ border: '1px solid #ccc', borderRadius: 6 }}>
      <div style={{ padding: 6 }}>
        <select
          disabled={disabled}
          onChange={(e) => {
            if (e.target.value) insertVariable(e.target.value);
            e.target.value = '';
          }}
          style={{
            padding: '4px 6px',
            fontSize: 14,
            borderRadius: 4,
            border: '1px solid #999',
            width: '100%',
          }}
        >
          <option value="">Insert Variable</option>
          {variables.map((v) => (
            <option key={v.variable_name} value={v.variable_name}>
              {v.title}
            </option>
          ))}
        </select>
      </div>

      <div
        ref={editorRef}
        contentEditable={!disabled}
        onInput={triggerChange}
        style={{
          minHeight: 80,
          padding: 10,
          fontSize: 14,
          backgroundColor: disabled ? '#f3f4f6' : 'white',
          borderTop: '1px solid #ccc',
        }}
        placeholder={placeholder}
        data-placeholder={placeholder}
      />
    </div>
  );
};

export default SmsEditor;
